import { get } from './api-service';

const routes = {
  metrics: 'dashboard-metrics',
};

export const getDashboardMetrics = async () => {
  return await get(routes.metrics);
};
